/* AKOERA Night : scripts du thème (sans dépendance) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Menu mobile ---------- */
  function initMenu() {
    var drawer = document.querySelector('[data-menu-drawer]');
    var openBtn = document.querySelector('[data-menu-open]');
    if (!drawer || !openBtn) return;
    var closeBtn = drawer.querySelector('[data-menu-close]');

    function open() {
      drawer.hidden = false;
      document.body.classList.add('menu-open');
      openBtn.setAttribute('aria-expanded', 'true');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      drawer.hidden = true;
      document.body.classList.remove('menu-open');
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.focus();
    }
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });
  }

  /* ---------- Onglets (gamme de modèles) ---------- */
  function initTabs(root) {
    root.querySelectorAll('[data-tabs]').forEach(function (group) {
      var tabs = Array.prototype.slice.call(group.querySelectorAll('[role="tab"]'));
      function select(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (next) { e.preventDefault(); select(next); next.focus(); }
        });
      });
    });
  }

  /* ---------- Traînées lumineuses (écho des lignes du monogramme) ---------- */
  function initTrails(root) {
    root.querySelectorAll('[data-light-trails]').forEach(function (canvas) {
      var ctx = canvas.getContext('2d');
      if (!ctx) return;
      var W = 0, H = 0, lines = [], running = false, raf = null;
      var transparent = !!canvas.closest('.hero--image');

      function size() {
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        W = canvas.clientWidth; H = canvas.clientHeight;
        canvas.width = W * dpr; canvas.height = H * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      function seed() {
        lines = [];
        var count = Math.round(Math.min(56, Math.max(18, W / 28)));
        for (var i = 0; i < count; i++) {
          lines.push({
            y: H * (0.15 + Math.random() * 0.72),
            x: Math.random() * W * 1.6 - W * 0.3,
            len: 60 + Math.random() * 420,
            v: 0.6 + Math.random() * 3.2,
            a: 0.05 + Math.random() * 0.4,
            w: Math.random() < 0.15 ? 1.6 : 0.7
          });
        }
      }
      function draw() {
        if (transparent) {
          ctx.clearRect(0, 0, W, H);
        } else {
          ctx.fillStyle = '#0A0A0B';
          ctx.fillRect(0, 0, W, H);
          var g = ctx.createRadialGradient(W * 0.7, H * 0.55, 0, W * 0.7, H * 0.55, W * 0.6);
          g.addColorStop(0, 'rgba(201,201,206,.07)');
          g.addColorStop(1, 'rgba(10,10,11,0)');
          ctx.fillStyle = g;
          ctx.fillRect(0, 0, W, H);
        }
        for (var i = 0; i < lines.length; i++) {
          var l = lines[i];
          var gr = ctx.createLinearGradient(l.x, 0, l.x + l.len, 0);
          gr.addColorStop(0, 'rgba(242,242,243,0)');
          gr.addColorStop(1, 'rgba(242,242,243,' + l.a + ')');
          ctx.strokeStyle = gr;
          ctx.lineWidth = l.w;
          ctx.beginPath();
          ctx.moveTo(l.x, l.y);
          ctx.lineTo(l.x + l.len, l.y);
          ctx.stroke();
          if (running) {
            l.x += l.v;
            if (l.x > W) {
              l.x = -l.len - Math.random() * W * 0.4;
              l.y = H * (0.15 + Math.random() * 0.72);
            }
          }
        }
        if (running) raf = requestAnimationFrame(draw);
      }
      function start() { if (running || reduceMotion) return; running = true; draw(); }
      function stop() { running = false; if (raf) cancelAnimationFrame(raf); }

      size(); seed(); draw();
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries[0].isIntersecting ? start() : stop();
        }).observe(canvas);
      } else {
        start();
      }
      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(function () { size(); seed(); if (!running) draw(); }, 150);
      });
    });
  }

  /* ---------- Fiche produit : choix de variante ---------- */
  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function initProduct(root) {
    root.querySelectorAll('[data-product]').forEach(function (el) {
      var jsonEl = el.querySelector('[data-product-json]');
      if (!jsonEl) return;
      var data;
      try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      var variants = data.variants || [];
      var fieldsets = Array.prototype.slice.call(el.querySelectorAll('[data-option-index]'));
      var idInput = el.querySelector('[data-variant-input]');
      var addBtn = el.querySelector('[data-add-button]');
      var addLabel = el.querySelector('[data-add-label]');
      var priceNow = el.querySelector('[data-price-now]');
      var priceWas = el.querySelector('[data-price-was]');

      function selected() {
        return fieldsets.map(function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
      }
      function match(opts) {
        return variants.find(function (v) {
          return opts.every(function (o, i) { return o === null || v.options[i] === o; });
        });
      }
      function markAvailability(opts) {
        fieldsets.forEach(function (fs, idx) {
          fs.querySelectorAll('input').forEach(function (input) {
            var test = opts.slice(); test[idx] = input.value;
            var any = variants.some(function (v) {
              return v.available && test.every(function (o, i) { return o === null || v.options[i] === o; });
            });
            var label = fs.querySelector('label[for="' + input.id + '"]');
            if (label) label.classList.toggle('is-unavailable', !any);
          });
        });
      }
      function update() {
        var opts = selected();
        fieldsets.forEach(function (fs, i) {
          var cur = fs.querySelector('[data-option-current]');
          if (cur) cur.textContent = opts[i] || '';
        });
        markAvailability(opts);
        var v = match(opts);
        if (!v) {
          if (addBtn) addBtn.disabled = true;
          if (addLabel) addLabel.textContent = 'Indisponible';
          return;
        }
        if (idInput) idInput.value = v.id;
        if (addBtn) addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
        if (priceNow) priceNow.textContent = formatMoney(v.price);
        if (priceWas) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            priceWas.textContent = formatMoney(v.compare_at_price);
            priceWas.hidden = false;
          } else {
            priceWas.hidden = true;
          }
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }

      fieldsets.forEach(function (fs) {
        fs.addEventListener('change', update);
      });
      if (fieldsets.length) markAvailability(selected());

      el.querySelectorAll('[data-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var input = btn.parentElement.querySelector('input');
          var n = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qty, 10));
          input.value = n;
        });
      });
    });
  }

  /* ---------- Tri des collections ---------- */
  function initSort() {
    document.querySelectorAll('[data-sort]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- Connexion : mot de passe oublié ---------- */
  function initRecover() {
    var login = document.querySelector('[data-login-view]');
    var recover = document.querySelector('[data-recover-view]');
    if (!login || !recover) return;
    function show(isRecover) { login.hidden = isRecover; recover.hidden = !isRecover; }
    document.querySelectorAll('[data-toggle-recover]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); show(recover.hidden); });
    });
    if (window.location.hash === '#recover' || recover.querySelector('.form-ok, .form-err')) show(true);
  }

  /* ---------- Apparition au défilement ---------- */
  function initReveal() {
    if (!document.body.classList.contains('has-reveal') || reduceMotion || !('IntersectionObserver' in window)) return;
    if (window.Shopify && Shopify.designMode) return;
    var targets = document.querySelectorAll('main .shopify-section:not(:first-child) .sec-head, main .shopify-section:not(:first-child) .model, main .shopify-section:not(:first-child) .split, main .shopify-section:not(:first-child) .look, main .shopify-section:not(:first-child) .posts, main .shopify-section:not(:first-child) .band-row');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (t) {
      var r = t.getBoundingClientRect();
      if (r.top < window.innerHeight) return; // déjà visible au chargement : on ne masque rien
      t.classList.add('reveal');
      io.observe(t);
    });
  }

  function initAll(root) {
    initTabs(root);
    initTrails(root);
    initProduct(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    initAll(document);
    initSort();
    initRecover();
    initReveal();
  });

  /* Éditeur de thème : réinitialiser une section rechargée */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
